<template>
  <div>
    <v-app-bar dense dark :fixed="true">
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.mdAndUp"
        @click.stop="toggleMiniSidebar()"
      />
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.smAndDown"
        @click.stop="showSidebar()"
      />

      <v-toolbar-title>
        <img
          style="width:120px; margin-top:12px"
          width="120px"
          :src="require('@/../static/logo.svg')"
        />
      </v-toolbar-title>

      <v-spacer />

      <language />
      <v-menu left bottom>
        <template v-slot:activator="{ on }" width="100px">
          <v-btn icon v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-list-item-title @click="logout()" class="logout-btn">
              {{ this.$t('header.user.logOut') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-toolbar-title v-if="$vuetify.breakpoint.smAndUp">{{
        userEmail
      }}</v-toolbar-title>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Language from '@/components/layout/Language.vue';

export default {
  data: () => ({}),
  components: {
    Language,
  },
  computed: {
    ...mapGetters({
      miniSidebar: 'global/getMiniSidebar',
      drawerSidebar: 'global/getDrawerSidebar',
    }),
    userEmail() {
      const user = JSON.parse(localStorage.getItem('me'));
      if (user) {
        return user.email;
      }
      return null;
    },
  },
  methods: {
    ...mapMutations({
      setMiniSidebar: 'global/setMiniSidebar',
      setDrawerSidebar: 'global/setDrawerSidebar',
    }),
    ...mapActions({
      logoutUser: 'auth/logOut',
    }),
    logout() {
      this.logoutUser();
      this.$router.push({ name: 'login' });
    },
    toggleMiniSidebar() {
      this.setDrawerSidebar(true);
      if (this.miniSidebar) {
        this.setMiniSidebar(false);
      } else {
        this.setMiniSidebar(true);
      }
    },
    showSidebar() {
      this.setMiniSidebar(false);
      this.setDrawerSidebar(true);
    },
  },
};
</script>

<style scoped>
.logout-btn {
  cursor: pointer;
}
</style>
